import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThumbDownCurved: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconThumbDownCurved"><Path d="M21.5 14.5H16.5V3.5H21.5V14.5Z" stroke="currentColor"/><Path d="M11.6273 21.4398L12.1159 21.5C13.5 17.5 16.5 15.3968 16.5 12.7293V5.88296C16.5 5.05824 16.0186 4.29601 15.2318 4.01382C12.5617 3.05621 9.76869 2.85136 6.94515 3.09236C5.22088 3.23953 3.86969 4.55101 3.48977 6.21405L2.58013 10.1959C2.1257 12.1851 3.66161 14.076 5.7318 14.076H10.9623L9.94039 17.347C9.34986 19.2373 9.6348 21.1945 11.6273 21.4398Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconThumbDownCurved;
